import React, { useState, useEffect } from 'react';
import { initFacebookPixel } from '../facebookPixel';
import './Faq.css'; 

const faqs = [
  {
    question: 'What is "Swimming Playing Membership"?',
    answer: 'Swimming playing membership refers to recreational or open swim hours where you can enjoy the pool without coaching or instruction.',
  },
  {
    question: 'Who can join the swimming play sessions?',
    answer: 'Swimming playing membership is for adults (Age 18 years or above). You can book a slot and bring your swimwear and join in.',
  },
  {
    question: 'Are there lifeguards during play hours?',
    answer: 'Yes, professional lifeguards are always present during operational hours to ensure your safety.',
  },
  {
    question: 'Do I need to book in advance?',
    answer: 'Yes, after you purchase playing membership, you can book your slots through the Machaxi app before coming for swimming.',
  },
  {
    question: 'Is there a time limit for playing sessions?',
    answer: 'Typically, play sessions are 60 minutes long. You can book multiple slots if you want extended time.',
  },
  {
    question: 'Can I swim if I don’t know how to?',
    answer: 'It’s best to stay in the shallow end if you\'re not confident. We also offer coaching if you’d like to learn and be more confident in water.',
  },
  {
    question: 'Are there changing rooms and showers available?',
    answer: 'Yes, our facilities include clean changing rooms, lockers, and showers for all participants.',
  },
  {
    question: 'What are the charges for swimming play sessions?',
    answer: 'We have monthly, quarterly, half yearly, and yearly pass options. Please check our pricing section or contact us.',
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpand = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };
  document.querySelectorAll('.faq-header-item').forEach(item => {
    item.addEventListener('click', () => {
      const answer = item.nextElementSibling;
  
      // Toggle the "open" class on the answer
      answer.classList.toggle('open');
    });
  });
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="faq-container">
      <h2 className="faq-header">FAQ's</h2>
      <ul className="faq-list">
        {faqs.map((faq, index) => (
          <li key={index} className="faq-item">
            <div
              className="faq-header-item"
              onClick={() => handleExpand(index)}
            >
               <span className={`faq-toggle ${expandedIndex === index ? 'expanded' : ''}`}>
                {expandedIndex === index ? '▾' : '▸'}
              </span>
              <span className="faq-question">{faq.question}</span>
             
            </div>
            <div className={`faq-answer ${expandedIndex === index ? 'open' : ''}`}>
              <pre>{faq.answer}</pre>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
